import { useEffect } from "react";
import { useAuthV2 } from "@cliently/auth-client";
import { setClerkTokenGetter, setClerkSignOut } from "../lib/api";

/**
 * Équivalent auth-v2 de `ClerkTokenProvider`. Branche l'intercepteur axios sur
 * le getter de token du store auth-v2 et expose le signOut, en réutilisant les
 * mêmes setters (`setClerkTokenGetter`/`setClerkSignOut`) pour ne pas casser
 * `lib/api.ts` qui est partagé. Les noms sont historiques.
 */
export const AuthV2TokenProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { getToken, signOut } = useAuthV2();

  useEffect(() => {
    setClerkTokenGetter(getToken);
    setClerkSignOut(signOut);
  }, [getToken, signOut]);

  return <>{children}</>;
};
